/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Panel_NextInputs */



/**
* | output |
* | --- |
* | "Next" |
*
* @param {Chat_Activity_Panel_NextInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_panel_next = /** @type {((inputs?: Chat_Activity_Panel_NextInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Panel_NextInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Volgende")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suivant")
	return /** @type {LocalizedString} */ ("Next")
});